import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";
import ServiceMember from "./ServiceMember";

export default class MemberUserCardService extends ServiceMember {
    constructor() {
        super();
        this.baseURL = 'security/user/member/card';
    }

    async updateDefaultCard(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/updateDefaultCard/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async createWithoutNotification(merchantBranchId, data) {
        data.merchantBranchId = merchantBranchId;
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
        });
    }


}